import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import React, { useEffect, useRef, useState } from "react";
import { SelectV2 } from "../../../../components/redesign-components/SelectV2/SelectV2";
import s from "./SwingTable.module.css";

export const Pagination = ({
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  pageNumber,
  rowsPerPage,
  showItemsPerPage = false,
}) => {
  const VISIBLE_RANGE = 3;

  const getDisplayedPages = () => {
    const pages = [];
    const start = Math.max(2, currentPage); // start from 2nd page
    const end = Math.min(pageNumber - 1, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const renderPageButton = (page) => (
    <button
      key={page}
      onClick={() => onPageChange(page - 1)}
      className={`${s.pageButton} ${
        currentPage === page - 1 && s.activePageButton
      }
      `}
    >
      {page}
    </button>
  );

  const renderEllipsis = (key) => (
    <div key={key} className={s.pageButton} style={{ cursor: "auto" }}>
      ...
    </div>
  );

  const changePage = (direction) => {
    const nextPage =
      direction === "forward" ? currentPage + 1 : currentPage - 1;
    if (nextPage >= 0 && nextPage < pageNumber) {
      onPageChange(nextPage);
    }
  };

  return (
    <div className={s.paginationContainer}>
      <button
        disabled={currentPage === 0}
        onClick={() => changePage("back")}
        className={s.paginationButton}
      >
        <ArrowBackIcon style={{ width: "20px", height: "20px" }} /> Previous
      </button>

      {/* Items per page selector */}
      {showItemsPerPage && (
        <SelectV2
          label="Items per page"
          name="rowsPerPage"
          onChange={(_, value) => onRowsPerPageChange(value)}
          options={[10, 20, 50, 100, 250].map((val) => ({
            text: val,
            value: val,
          }))}
          value={rowsPerPage}
          width="100px"
        />
      )}

      {/* Page numbers */}
      <div style={{ display: "flex", gap: "10px" }}>
        {renderPageButton(1)}

        {currentPage >= VISIBLE_RANGE && renderEllipsis("left")}

        {getDisplayedPages().map(renderPageButton)}

        {currentPage <= pageNumber - VISIBLE_RANGE - 1 &&
          renderEllipsis("right")}

        {pageNumber > 1 && renderPageButton(pageNumber)}
      </div>

      {showItemsPerPage && <div style={{ width: "100px" }} />}

      <button
        disabled={currentPage >= pageNumber - 1}
        onClick={() => changePage("forward")}
        className={s.paginationButton}
      >
        Next <ArrowForwardIcon style={{ width: "20px", height: "20px" }} />
      </button>
    </div>
  );
};
